import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigRepository } from '../../../../../shared/repositories/config.repository';
import { AdditionalPageShortDto } from '../../../../../api/v1/models/additional-page-short-dto';
import { map } from 'rxjs/operators';
import { LangSwitchComponent } from '../lang-switch/lang-switch.component';
import { LANG_OPTIONS } from '../../../../../shared/tokens/langOptions/lang-options';

@Component({
  selector: 'app-header-nav',
  standalone: true,
  templateUrl: './header-nav.component.html',
  styleUrls: ['./header-nav.component.scss'],
  imports: [
    CommonModule,
    RouterLink,
    LangSwitchComponent,
  ]
})
export class HeaderNavComponent {
  constructor(
    private configRepository: ConfigRepository,
  ) {}

  langOptions = inject(LANG_OPTIONS);

  isShowLangSwitch: boolean = !!Object.keys(this.langOptions).length;
  additionalAbout$: Observable<AdditionalPageShortDto | undefined> =  this.configRepository.additionalAbout$;

  isShowActionsLink$: Observable<boolean> = this.configRepository.promotionCount$.pipe(
    map(count => !!count)
  );
  additionalPages$ = this.configRepository.additionalPages$;
}
